module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-2560-2986d3e454e3e79a2de0e02eaf56cd00.jpg";